<template>
  <el-container id="tab">
    <div v-if="!allowCostPrice" style="margin: auto">
      <img :src="require('@/assets/image/default/no-power.png')" style="margin: 0 0 10px 30px" width="150px">
      <p style="font-size: 18px;text-align: center;">对不起，您暂无访问权限</p>
      <p style="font-size: 14px;text-align: center;">（如有需要，请联系管理员授权）</p>
    </div>
    <el-aside v-if="allowCostPrice" :width="isCollapse ? '20px' : '300px'">
      <el-card v-show="!isCollapse" class="box-card" shadow="never">
        <div slot="header">
          <span>查询条件</span>
          <el-button style="float: right; padding: 3px 0" icon="el-icon-d-arrow-left" type="text"
            @click="isCollapse = !isCollapse"></el-button>
        </div>
        <el-form ref="queryFormRef" :rules="queryFormRules" :model="queryForm" label-width="84px" size="small">
          <el-scrollbar>
            <el-form-item label="商品" prop="product.selected">
              <el-select class="select_multiple" ref="productSelectRef" v-model="queryForm.product.selected"
                value-key="value" multiple clearable placeholder="请选择商品名称" @click.native="productInputFocus">
                <el-option v-for="item in queryForm.product.list" :key="item.value" :label="item.text"
                  :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="变化日期" prop="billDate.selected">
              <date-picker style="width: 100%;" v-model="queryForm.billDate.selected" type="daterange" align="right"
                unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                :value-format="'yyyy-MM-dd'" :picker-options="pickerOptions">
              </date-picker>
            </el-form-item>
            <el-form-item label="单据类型" prop="billType.selected">
              <select-multiple class="select_multiple" :select-data="queryForm.billType"></select-multiple>
            </el-form-item>
            <el-form-item label="成本价类型" prop="costPriceType.selected">
              <select-multiple class="select_multiple" :select-data="queryForm.costPriceType"></select-multiple>
            </el-form-item>
          </el-scrollbar>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
      <div class="is-collapse" v-show="isCollapse" @click="isCollapse = !isCollapse">
        <span style="text-align: center;">查询</span>
        <el-button icon="el-icon-d-arrow-right" type="text"></el-button>
        <span style="text-align: center;">条件</span>
      </div>
    </el-aside>
    <el-main v-if="allowCostPrice">
      <el-tabs type="border-card" v-model="activeName" @tab-click="tabClick">
        <el-tab-pane label="成本变化记录" name="fourth" ref="fourth" :lazy="true">
          <el-card shadow="never" v-if="activeName == 'fourth'">
            <el-form :inline="true" size="small">
              <div>
                <el-form-item label="变化日期:">
                  <span>{{ billDate[0] }}</span>
                  <span style="margin: 0 6px;">至</span>
                  <span>{{ billDate[1] }}</span>
                </el-form-item>
                <el-form-item label="所选商品:">
                  <span>{{ selecteProduct.length ? selecteProduct : '无' }}</span>
                </el-form-item>
              </div>
              <!-- <el-form-item class="dropdown">
                <el-dropdown @command="handleCommand">
                  <el-button type="primary">
                    导出<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="A">导出</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-form-item> -->
            </el-form>
          </el-card>
          <div class="table" v-if="activeName == 'fourth'" v-loading="tableLoading"
            style="height: calc(100% - 10px - 32px);">
            <el-table ref="table" :data="tableData" style="width: 100%" border stripe height="100%" max-height="100%">
              <el-table-column type="index" width="55">
                <!-- <template slot="header">
                  <el-tooltip slot="reference" class="item" effect="dark" content="设置隐藏列(点击显示/隐藏)" placement="top">
                    <el-button icon="el-icon-s-tools" type="text" @click="getCustomColumns"></el-button>
                  </el-tooltip>
                </template> -->
              </el-table-column>
              <el-table-column prop="itemName" label="商品" width="200"></el-table-column>
              <el-table-column prop="currentSalCostPrice" label="当前成本价(大)" width="120" v-if="allowCostPrice"></el-table-column>
              <el-table-column prop="currentInvCostPrice" label="当前成本价(小)" width="120" v-if="allowCostPrice"></el-table-column>
              <el-table-column prop="billType" label="单据类型" width="120"></el-table-column>
              <el-table-column prop="costPriceType" label="成本价类型" width="120"></el-table-column>
              <el-table-column prop="entryTime" label="发生时间" width="100">
                <template slot-scope="{ row }">
                  <!-- <span style="margin-right: 6px;">{{ row.entryDate }}</span>
                  <span>{{ row.entryTime }}</span> -->
                  <p>{{ row.entryDate }}</p>
                  <p>{{ row.entryTime }}</p>
                </template>
              </el-table-column>
              <el-table-column prop="entryUserName" label="操作人" width="120"></el-table-column>
            </el-table>
          </div>
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="pagination.page" :page-sizes="[10, 20, 100]" :page-size="pagination.size"
            layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
        </el-tab-pane>
      </el-tabs>
    </el-main>
  </el-container>
</template>

<script>
import selectProduct from '@/components/common/selectProduct.vue'
import datePicker from '@/components/common/datePicker.vue'
import { toRawType, pickerOptions, getAddDate, getNowFormatDate, exportExcelCommonForVue } from '@/assets/js/common.js'
export default {
  name: "InventoryQuery",
  components: {
    selectProduct,
    datePicker
  },
  data() {
    let activeName = 'fourth'
    let beginDate = getAddDate(-3)
    let endDate = getNowFormatDate()
    return {
      isCollapse: false,
      activeName: activeName,
      queryForm: {
        product: { submitName: 'itemID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择商品名称', request: { url: '/Account/itemMasterDefine/selectItemMastForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
        // sortField: { submitName: 'sortField', selected: '' },
        billType: { submitName: 'billType', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择单据类型', request: { url: '/Account/finance/costAdjust/selectCostBillTypeList.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
        costPriceType: { submitName: 'costPriceType', selected: { text: '移动加权平均价', value: '1' }, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择成本调价类型', request: { url: '/Account/finance/costAdjust/selectCostTypeList.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
        // softBy: { submitName: 'softBy', selected: '' },
        billDate: { submitName: 'billDate', selected: [beginDate, endDate] },
      },
      pickerOptions: pickerOptions,
      tableLoading: false,
      tableData: [],
      summaries: {},
      pagination: {
        page: 1,
        size: 10,
        total: 0
      },
      billDate: [],
      selecteProduct: [],
      queryFormRules: {
        'product.selected': [
          { required: true, message: '请选择商品', trigger: 'change' }
        ],
      },
      allowCostPrice: true,
      priceArgs: {
          url: "/Account/dataSearchVue/getUserAllowCostPrice.html",
          code: 'isCostChange'
      }
    }
  },
  created() {
    let unwatch = this.$watch('$store.state.power', (val) => {
      if(val.enterpriseVersion >= 100){
        this.getPriceShow()
      }else {
        this.getTableData()
      }
      unwatch()
    })
  },
  mounted() {
    window.top.addEventListener('message', this.messageOfSelect)
  },
  beforeDestroy() {
    window.top.removeEventListener('message', this.messageOfSelect)
  },
  computed: {
    queryItem() {
      let tempItem = {}
      Object.values(this.queryForm).forEach(item => {
        if (toRawType(item.selected) == 'Array') {
          if (item.submitName == 'billDate') {
            tempItem['beginSearchDate'] = item.selected[0] || ''
            tempItem['endSearchDate'] = item.selected[1] || ''
            return false
          }
          tempItem[item.submitName] = item.selected.map(i => "'" + i.value + "'").join(',') || ''
        } else if (toRawType(item.selected) == 'String') {
          tempItem[item.submitName] = item.selected || ''
        } else if (toRawType(item.selected) == 'Object') {
          tempItem[item.submitName] = item.selected.value || ''
        }
      })
      return tempItem
    }
  },
  methods: {
    tabClick() {
      // this.queryForm.sortField.selected = ''
      // this.queryForm.softBy.selected = ''
      this.pagination.page = 1
      this.pagination.size = 10
      this.pagination.total = 0
      this.tableData = []
      this.summaries = {}
      this.onSubmit()
    },
    productInputFocus() {
      this.$refs['productSelectRef'].blur()
      window.top.openDialog55('选择商品', '/Account/sys/common/productSelect.html?tag=InvChangeProduct')
    },
    async getPriceShow() {
      const { data: res } = await this.$http.post(this.priceArgs.url, this.Qs.stringify(this.priceArgs))
      this.allowCostPrice = res.result == 'Y'
      this.getTableData()
    },
    messageOfSelect(e) {
      let { data: res } = e
      if (res.tag == 'InvChangeProduct') {
        if (res.code != 'success') return false
        this.$set(this.queryForm.product, 'list', res.data)
        this.queryForm.product.selected = res.data
        top.layer.closeAll('iframe')
      }

    },
    async getTableData() {
      this.tableLoading = true
      try {
        const { data: res } = await this.$http.post('/Account/finance/costAdjust/selectItemCostPriceDetailList.html', this.Qs.stringify({ ...this.queryItem, ...this.pagination }))
        this.tableLoading = false
        if (res.code != 'success') return this.$message.error(res.message)
        let { total, rows } = JSON.parse(res.result)
        this.pagination.total = total
        this.tableData = rows
      } catch (e) {
        console.log(e)
        this.tableLoading = false
      }
    },
    onSubmit() {
      this.pagination = {
        page: 1,
        size: 10,
        total: 0
      }
      this.billDate = [...this.queryForm.billDate.selected]
      this.selecteProduct = this.queryForm.product.selected.map(i => i.text)
      this.getTableData()
    },
    onReset() {
      this.$refs['queryFormRef'].resetFields()
    },
    handleSizeChange(newSize) {
      this.pagination.size = newSize
      this.getTableData()
    },
    handleCurrentChange(newPage) {
      this.pagination.page = newPage
      this.getTableData()
    },
    sortChange({ prop, order }) {
      let orderStr = ''
      if (order == 'descending') {
        orderStr = 'DESC'
      } else if (order == 'ascending') {
        orderStr = 'ASC'
      }
      this.queryForm.sortField.selected = prop.split('/')[0]
      this.queryForm.softBy.selected = orderStr
      this.getTableData()
    },
    handleCommand(command) {
      let $table = this.$refs.table
      let exportExcelUrl = ''
      if (this.activeName.match(/first|second/i)) {
        exportExcelUrl = command == 'A' ? '/Account/invMasterVueSearch/exportInvItemMasterExcel.html' : '/Account/invMasterVueSearch/exportInvItemMasterExcelWithSplit.html'
      } else if (this.activeName.match(/third|five/i)) {
        exportExcelUrl = '/Account/invMasterVueSearch/exportInvItemChangeExcel.html'
      } else if (this.activeName == 'fourth') {
        exportExcelUrl = '/Account/invMasterVueSearch/exportInvItemTransExcel.html'
      }
      if (command.match(/A|B/i)) {
        console.log(exportExcelUrl)
        this.exportExcel(exportExcelUrl, $table)
      }
    },
    exportExcel(url, $table) {
      let tempArr = $table.$children.map(item => {
        if (item.prop && item.prop.match(/\//)) {
          let label = item.label.split('/')
          let prop = item.prop.split('/')
          return [
            {
              label: label[0],
              prop: prop[0]
            },
            {
              label: label[1],
              prop: prop[1]
            }
          ]
        } else {
          return {
            label: item.label,
            prop: item.prop
          }
        }
      }).filter(item => (item.prop || Array.isArray(item))).flat()
      if (url) {
        exportExcelCommonForVue(this.queryItem, tempArr, url)
      }
      console.log(tempArr)
    }
  }
};
</script>

<style scoped lang="less">
#tab {

  // height: calc(100vh - 20px);
  .el-aside {
    .box-card {
      height: calc(100% - 2px);

      ::v-deep .el-card__header {
        padding: 8px 20px;
        height: 33px;
      }

      ::v-deep .el-card__body {
        padding: 6px;
        height: calc(100% - 33px);

        .el-form {
          height: calc(100% - 48px);

          .el-scrollbar {
            height: 100%;
          }
        }
      }
    }

    .is-collapse {
      width: calc(100% - 2px);
      height: calc(100% - 2px);
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;
      border: 1px #DCDFE6 solid;
      cursor: pointer;
      background-color: rgba(83, 168, 255, 0.1);
      color: #409EFF;
    }

    .select_multiple {
      ::v-deep .el-select__tags {
        max-height: 80px;
        overflow-y: auto;
        overflow-x: hidden;
      }
    }
  }

  .el-main {
    padding: 0 0 0 6px;

    .el-tabs {
      height: calc(100% - 2px);
      box-shadow: none;

      ::v-deep .el-tabs__item {
        height: 34px;
        line-height: 34px;
      }

      ::v-deep .el-tabs__content {
        height: calc(100% - 33px);
        padding: 0 12px 0;

        .el-tab-pane {
          height: 100%;
          display: flex;
          flex-flow: column;

          .el-card__body {
            padding: 12px;

            .el-form {
              height: 33px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              overflow: auto;

              &>div:nth-child(1) {
                height: 33px;
                display: flex;
                overflow: auto;
                flex-wrap: wrap;
                flex: 1;
              }

              .el-form-item {
                margin: 0 10px 0 0;
              }

              .el-form-item.dropdown {
                margin: 0;
                width: 101px;
              }
            }
          }

          .table {
            flex: 1;
            // height: calc(100% - 60px - 32px);
            box-sizing: border-box;

            .el-table {

              th,
              td {
                padding: 6px 0;

                .cell {
                  font-size: 14px;
                  // padding: 0;
                }
              }

              .border {
                font-size: 12px;
                color: #f56c6c;
                // border-top: 1px solid rgb(235, 238, 245);
              }
            }
          }
        }
      }
    }
  }

  .detail_drawer {
    display: flex;
    flex-flow: column;

    .el-container {
      height: 100%;
    }

    .el-header {
      height: auto !important;

      .el-row .el-col {
        margin-top: 12px;
        color: #303133;
      }
    }

    .el-main {
      display: flex;
      flex-flow: column;
      position: relative;
      flex: 1;

      .el-tabs {
        height: 48px;

        ::v-deep .el-tabs__content {
          display: none;
        }
      }

      .tabForm {
        position: absolute;
        height: 34px;
        line-height: 34px;
        top: 0;
        right: 12px;
      }

      .drawer_table {
        flex: 1;

        ::v-deep .el-table {

          th,
          td {
            padding: 0;

            .cell {
              font-size: 14px;
              padding: 0;
            }
          }

          .border {
            font-size: 12px;
            color: #f56c6c;
            border-top: 1px solid rgb(235, 238, 245);
          }
        }
      }
    }
  }

  ::v-deep .product-dialog {
    min-width: 1080px;
  }
}
</style>
